package com.milta.feature.importjobs.domain.usecase

import com.milta.feature.importjobs.domain.entity.ImportJob
import com.milta.feature.importjobs.domain.entity.ImportJobFlow
import com.milta.feature.importjobs.domain.repository.ImportJobRepository

/** POST /api/v1/import-jobs/{flow} — drops the file and gets the job back immediately (Pending). */
class SubmitImportJobUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(
        flow: ImportJobFlow,
        fileBytes: ByteArray,
        fileName: String,
        routeId: String?,
        onUpload: (sentBytes: Long, totalBytes: Long) -> Unit = { _, _ -> },
    ): ImportJob = repository.submit(flow, fileBytes, fileName, routeId, onUpload)
}

/** GET /api/v1/import-jobs/{id} */
class GetImportJobUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(id: String): ImportJob = repository.get(id)
}

/** GET /api/v1/import-jobs?active=true — running jobs plus finished ones not yet acknowledged. */
class ListActiveImportJobsUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(): List<ImportJob> = repository.listActive()
}

/** Relaunches a failed job from the file already stored server-side. */
class RetryImportJobUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(flow: ImportJobFlow, id: String): ImportJob = repository.retry(flow, id)
}

/** Abandons a Pending, Processing or Failed job. */
class CancelImportJobUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(id: String): ImportJob = repository.cancel(id)
}

/** Tells the server the result was consumed, so the job leaves the active list. */
class AcknowledgeImportJobUseCase(private val repository: ImportJobRepository) {
    suspend operator fun invoke(id: String) = repository.acknowledge(id)
}
